import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { Contract } from '../../interfaces/work-orders/contract';
import { ContractTotals } from '../../interfaces/work-orders/contract-totals';
import { WorkOrderSimplified } from '../../interfaces/work-orders/work-order-simplified';
import { ContractBudget } from '../../interfaces/work-orders/contract-budget';

@Injectable()

export class ContractsService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  totals(): Observable<ContractTotals | boolean> {
    return new Observable<ContractTotals | boolean>((o: Subscriber<ContractTotals | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('work-orders.contracts.index.totals')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ContractTotals>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  all(): Observable<Contract[] | boolean> {
    return new Observable<Contract[] | boolean>((o: Subscriber<Contract[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('work-orders.contracts.index')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Contract[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<Contract | boolean> {
    return new Observable<Contract | boolean>((o: Subscriber<Contract | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('work-orders.contracts.read', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Contract>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  workOrders(id: number): Observable<WorkOrderSimplified[] | boolean> {
    return new Observable<WorkOrderSimplified[] | boolean>((o: Subscriber<WorkOrderSimplified[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('work-orders.contracts.work-orders', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WorkOrderSimplified[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  budget(id: number): Observable<ContractBudget | boolean> {
    return new Observable<ContractBudget | boolean>((o: Subscriber<ContractBudget | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('work-orders.contracts.budget', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ContractBudget>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  uploadAttachments(id: number, formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('work-orders.contracts.upload-attachments', {':id': id}), formData);
  }

  deleteAttachment(id: number, attachment_id: number): Observable<ServerResponse> {
    return this.api.delete(this.apiEndpoints.get('work-orders.contracts.delete-attachment', {':id': id, ':attachment_id': attachment_id}));
  }

  downloadAttachment(id: number, attachment_id: number): void {
    this.api.download(this.apiEndpoints.get('work-orders.contracts.download-attachment', {':id': id, ':attachment_id': attachment_id}));
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('work-orders.contracts.create'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('work-orders.contracts.update', {':id': id}), formData);
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('work-orders.contracts.delete', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (response) {
            o.next(true);
          } else {
            o.next(false);
          }
        },
        (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  restore(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('work-orders.contracts.restore', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (response) {
            o.next(true);
          } else {
            o.next(false);
          }
        },
        (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
